import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "links"]

  toggle() {
    const expanded = this.toggleTarget.getAttribute("aria-expanded") !== "true"
    this.toggleTarget.setAttribute("aria-expanded", String(expanded))
    this.linksTargets.forEach((links) => { links.hidden = !expanded })
  }
}
